import {AvailabilityType} from "../../Widgets/ModalWidget/Composables/Constants";
import {FloatingWidgetConfigurationInput} from "../../Contracts/WidgetTypes/FloatingWidgetType";

export type ImageSizes = {
    small?: string
    medium?: string
    large?: string
    maximum?: string
}
export type MediaType = "IMAGE" | "IMAGE_WEBSITE" | "DOCUMENT" | "MAP";
export const EXPERIENCE = "EXPERIENCE";
export const FLEX_OFFER = "FLEX_OFFER";
export type InventoryType = typeof EXPERIENCE | typeof FLEX_OFFER;
export type Inventory = Experience | FlexOffer;
export type MediaImageDescription = {
    locale: string;
    text: string;
}

export type MediaImage = {
    id?: string;
    sort?: number;
    sizes?:ImageSizes;
    url?: string,
    type?: MediaType,
    description?: MediaImageDescription[];
}

export interface Card {
    url: string;
    description: string;
}

export type ExperienceOption = {
    id: string,
    durationInMinutes: number,
    title:string,
    restrictions: {
        cutoffBeforeBegin: number,
        cutoffBeforeEnd: number,
    }
};


export type BookingRestriction = {
    minParticipants: number,
    strictMinimumPerBooking: boolean,
}

export type Experience = {
    inventoryType: InventoryType,
    id: string,
    title: string,
    description: string,
    options: ExperienceOption[],
    coverImage?: MediaImage,
    availabilityType: AvailabilityType,
    latestBookingTime: number,
    experienceLocation: { placeId?: string}
    translations: { locale: string, properties: Record<string, string> }[],
    media?:MediaImage[],
    requiresVendorConfirmation?:boolean,
    bookingRestriction: BookingRestriction
}
export type RedemptionRange = {
    type : 'DATE_RANGE',
    startDate: Date;
    endDate: Date;
} | {
    type: 'DAYS_AFTER_PURCHASE',
    daysAfterPurchase: number,
}

export type FlexOfferRestriction = {
    numberOfRedemptions?: number | null,
    limitedStockAmount?: number | null;
    redemptionRange?: RedemptionRange;
    purchaseDateRange?: {
        startDate: Date;
        endDate: Date;
    };
}

export const FLEXOFFERTYPE = {
    SEASON_PASS: 'SEASON_PASS',
    FLEX_OFFER: 'FLEX_OFFER',
    OPEN_DATE_TICKET: 'OPEN_DATE_TICKET',
} as const;

export type FlexOfferType = typeof FLEXOFFERTYPE[keyof typeof FLEXOFFERTYPE];

export type FlexOffer = {
    inventoryType: InventoryType,
    id: string,
    name: string,
    type: FlexOfferType,
    description: string,
    experienceId: string,
    optionId: string,
    experience?: Experience,
    coverImage?: MediaImage,
    media?:MediaImage[],
    prices?: FlexOfferPrice[],
    restrictions?: FlexOfferRestriction,
};

export type Money = {
    amount: number,
    currency: string,
}

export type EntryUnit = {
    type: string,
}

export const FLEX_OFFER_PRICE_TYPE = {
    PURCHASE: 'PURCHASE',
    RENEWAL: 'RENEWAL',
} as const;

export type FlexOfferPriceType = typeof FLEX_OFFER_PRICE_TYPE[keyof typeof FLEX_OFFER_PRICE_TYPE];

export type FlexOfferPrice = {
    id: string,
    price: Money,
    title: string,
    entryUnits: EntryUnit[],
    type: FlexOfferPriceType
}

export type Availability = {
    id: string,
    experienceId: string,
    optionID: string,
    totalCapacity: number,
    startTime: Date,
    startTimeLocal: Date,
    availableSlots: number,
    startTimeUtcString: string,
    startTimeLocalString:string,
}

export type Widget = {
    supplierId: string,
    widgetId:string,
    config?: FloatingWidgetConfigurationInput,
}
